import { render, staticRenderFns } from "./qiefen.vue?vue&type=template&id=31fdf418&scoped=true&"
import script from "./qiefen.vue?vue&type=script&lang=ts&"
export * from "./qiefen.vue?vue&type=script&lang=ts&"
import style0 from "./qiefen.vue?vue&type=style&index=0&id=31fdf418&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fdf418",
  null
  
)

export default component.exports